// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppEvent } from '@interfaces/interfaces';
import { ModalSize } from '@interfaces/shared.interfaces';
import { DocumentsService } from '@services/documents.service';
import { ErrorService } from '@services/error.service';
import { SharedService } from '@services/shared.service';
import { PDFDocumentProxy } from 'ng2-pdf-viewer';
import { catchError } from 'rxjs';

@Component({
    selector: 'lightweight-pdf-view-modal',
    templateUrl: './lightweight-pdf-view-modal.component.html',
    styleUrls: ['./lightweight-pdf-view-modal.component.scss'],
})
export class LightweightPdfViewModalComponent implements OnInit {
    @Input() dealerId: number = null;
    @Input() dealId: number = null;
    @Input() documentId: number = null;
    @Input() document: any = null;
    @Input() printButtonVisible = true;
    @Input() downloadButtonVisible = true;

    public pdfUrl: string;
    public isLoading = true;
    public viewerHeight: number;
    public viewerWidth: number;

    constructor(
        private dialogRef: MatDialogRef<LightweightPdfViewModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private readonly documentsService: DocumentsService,
        private readonly errorService: ErrorService,
        private readonly sharedService: SharedService
    ) {
        this.dealerId = this.data.dealerId;
        this.dealId = this.data.dealId;
        this.documentId = this.data.documentId;
        this.document = this.data.document;
        this.printButtonVisible = this.data.printButtonVisible;
        this.downloadButtonVisible = this.data.downloadButtonVisible ?? true; //added for internal-document-intervention-modal
        this.viewerHeight = this.sharedService.getModalInnerContentHeight(ModalSize.Large);
        this.viewerWidth = this.sharedService.getModalInnerContentWidth(ModalSize.Large);
    }

    async ngOnInit(): Promise<void> {
        this.documentsService
            .getSignedFileByPath$(this.dealId, this.documentId)
            .pipe(
                catchError((error) => {
                    this.errorService.showGenericError();
                    throw error;
                })
            )
            .subscribe((response) => {
                this.pdfUrl = response.data.filename;
            });
    }

    async onPdfLoadComplete(event: PDFDocumentProxy) {
        this.isLoading = false;
    }

    onError(error: any) {
        console.error(error);
        this.isLoading = false;
        this.errorService
            .showErrorAtService({
                message: 'Could not load the document because it is broken. Please try again. If the issue continues please contact support.',
                title: 'Corrupted Document',
            })
            .afterClosed()
            .subscribe((result) => this.dialogRef.close());
    }

    public eventHandler(event: AppEvent): void {}

    public closeModal() {
        this.dialogRef.close();
    }

    public isPrintButtonVisible() {
        return this.printButtonVisible;
    }

    public isDownloadButtonVisible() {
        return this.downloadButtonVisible;
    }

    public pdfStyle() {
        return `height: ${this.viewerHeight}px; width: ${this.viewerWidth} px`;
    }

    public printPdf() {
        window.open(this.pdfUrl).print();

        const doc = this.documentsService.getDocById(this.documentId);
        this.documentsService.updateDocumentInfo(doc, doc.displayName, doc.isDealerOnly, 'Print').subscribe();
    }
}
